import React from 'react';

/**
 * NoteButton — triggers the notes panel.
 *
 * contextAnchor: optional { type: 'timestamp'|'slide', value: number }
 *   Informational — the parent uses it to pre-fill the NoteEditor with
 *   the current video timestamp or slide index when the button is clicked.
 *   The button itself does not use this value directly.
 */
export default function NoteButton({ onClick, hasNotes = false, style = {}, contextAnchor = null }) {
  return (
    <button
      onClick={onClick}
      title={hasNotes ? 'View/add notes' : 'Add a note'}
      style={{
        background: hasNotes ? 'var(--accent-color, #3b82f6)' : 'var(--surface-secondary, #f3f4f6)',
        color: hasNotes ? '#fff' : 'var(--text-secondary, #6b7280)',
        border: '1px solid var(--border-color, #d1d5db)',
        borderRadius: '50%', width: 36, height: 36,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', fontSize: '1rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        transition: 'all 0.15s',
        ...style,
      }}
    >
      {hasNotes ? '📝' : '✏️'}
    </button>
  );
}
